export default __webpack_public_path__ + "img/favicons/browserconfig.xml";